<template>
  <div class="header-bar">
    <div class="header-bar-logo" v-if="tenantConfig?.logoUrl">
      <img :src="tenantConfig.logoUrl" alt="Logo" />
    </div>
    <div class="header-bar-main">
      <h1>{{ tenantConfig?.name || 'Screenmanagement' }}</h1>
      <div class="header-bar-date">
        {{ formatDate(new Date()) }}
      </div>
    </div>
    <div v-if="$store.state.user" class="header-bar-user">
      <router-link to="/profile">
        <span style="font-weight: bold;">{{ $store.state.user.lastName }}</span>, {{ $store.state.user.firstName }}
      </router-link>
      <div style="cursor: pointer;" @click="this.destroySession();" v-html="getSVG('logout')" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    tenantConfig() {
      return this.$store.state.tenantConfig;
    },
  }
}
</script>